import { jsonClient } from '../lib/api';

const jobsByOfficeId = (officeId) => (job) => {
  const { offices = [] } = job;
  return offices.find((office) => office.id === officeId);
};

function JobList(initialData) {
  const { officeId } = JSON.parse(initialData);

  return {
    jobs: [],
    officeId: null,
    state: 'idle',
    init() {
      this.fetchJobs();
    },
    fetchJobs() {
      this.state = 'loading';
      const baseUrl =
        'https://boards-api.greenhouse.io/v1/boards/valohealth/jobs?content=true';

      jsonClient(baseUrl).then(({ jobs = [] }) => {
        this.jobs = officeId ? jobs.filter(jobsByOfficeId(officeId)) : jobs;
        this.state = 'idle';
      });
    },
  };
}

export default JobList;
